import { Navigate, Route, Routes } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

import { AppShell } from '@/components/AppShell';
import { ToastProvider } from '@/components/Toast';
import { useAuth } from '@/auth/AuthContext';
import { ClubsPage } from '@/pages/ClubsPage';
import { ClubOverviewPage } from '@/pages/ClubOverviewPage';
import { CommunityPage } from '@/pages/CommunityPage';
import { FinancePage } from '@/pages/FinancePage';
import { LoginPage } from '@/pages/LoginPage';
import { OverviewPage } from '@/pages/OverviewPage';
import { LeaderboardsPage } from '@/pages/LeaderboardsPage';
import { PeoplePage } from '@/pages/PeoplePage';
import { PersonDetailPage } from '@/pages/PersonDetailPage';
import { ScoringPage } from '@/pages/ScoringPage';
import { TeamsPage } from '@/pages/TeamsPage';
import { VipCodesPage } from '@/pages/VipCodesPage';
import { IosDevicesPage } from '@/pages/IosDevicesPage';
import { MarketingConsentsPage } from '@/pages/MarketingConsentsPage';
import { LicensesPage } from '@/pages/LicensesPage';
import { DataScopeProvider } from '@/lib/dataPurpose';

export function App() {
  const { account, checking } = useAuth();

  if (checking) {
    // Held here until the stored token has been checked. Without it the
    // sign-in screen flashes for anybody who is already signed in.
    return (
      <div className="flex min-h-dvh items-center justify-center bg-brand">
        <Loader2 aria-label="…" className="h-6 w-6 animate-spin text-white/70" />
      </div>
    );
  }

  if (!account) return <LoginPage />;

  return (
    <ToastProvider>
      <DataScopeProvider>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<OverviewPage />} />
          <Route path="leaderboards" element={<LeaderboardsPage />} />
          <Route path="people" element={<PeoplePage />} />
          <Route path="people/:personId" element={<PersonDetailPage />} />
          <Route path="marketing-consents" element={<MarketingConsentsPage />} />
          <Route path="clubs" element={<ClubsPage />} />
          <Route path="clubs/:clubId" element={<ClubOverviewPage />} />
          <Route path="licenses" element={<LicensesPage />} />
          <Route path="teams" element={<TeamsPage />} />
          <Route path="finance" element={<FinancePage />} />
          <Route path="vip-codes" element={<VipCodesPage />} />
          <Route path="ios-devices" element={<IosDevicesPage />} />
          <Route path="scoring" element={<ScoringPage />} />
          <Route path="community" element={<CommunityPage />} />
          {/* Anything unknown goes to the overview rather than a dead end. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      </DataScopeProvider>
    </ToastProvider>
  );
}
